export default {
  // crypto
  'BTCUSDT': 'Bitcoin',
  'ETHUSDT': 'Ethereum',
  'XRPUSDT': 'Ripple',
  'BNBUSDT': 'Binance',
  'SOLUSDT': 'Solana',
  'DOGEUSDT': 'Dogecoin',
  'ADAUSDT': 'Cardano',
  'LINKUSDT': 'Link',
  'BCHUSDT': 'Bitcoin Cash',
  'LTCUSDT': 'Litecoin',
  'EOSUSDT': 'EOS',
  // virtual
  'BFULLL': 'Crashcoin',
  'LALLLL': 'Ker\'ching',
  'MLMLLL': 'Shilling',
  'WKWLLL': 'Spoofcoin',
  'G100': 'BubbleBit',
  '5YR': 'Moonshine',
  '10YR': 'BullnBear',
  'BMSTM': 'TitBit',
  'CRDM': 'TwoBit',
  'KNBW': 'MegaBit',
};
